import * as actionTypes from './actionTypes'
import { fromJS } from 'immutable'

const defaultState = fromJS({
    msg: 'this.is.home.redux.store.msg',
    routerloading: 1
})



export default (state = defaultState, action) => {


    switch (action.type) {
        case actionTypes.GET_ROUTER_LOADING:
            return state.set('routerloading', action.data)

        default:
            return state;
    }
}
